// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2OBPI","selected":"Chip_selected__pDhUB"};